import { render, staticRenderFns } from "./AppRgField.vue?vue&type=template&id=202c8700&"
import script from "./AppRgField.vue?vue&type=script&lang=js&"
export * from "./AppRgField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports